import React from 'react';

if (process.browser) require('./Headline.scss');

export default function Headline({ children }) {
  return (
    <div className="headline" data-name="headline">
      <div className="with-container">
        { children }
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Headline/Headline.js